import Head from 'next/head';
import styles from '@styles/labs/shorts.module.scss';
import { useState } from 'react';
import Logo from '../../../public/logo.svg';
import VOLI from '../../../public/VOLI.svg';

const scriptList = [
    '나야, 들기름',
    '저는 채소의 익힘 정도를 굉장히 중요시 여기거덩요',
    '탈락입니다! 너무짜요!',
    '좋았어, 진행시켜',
    '니 내 누군지 아니?',
    '내 이름은 코난, 탐정이죠',
    '지금까지 이런 맛은 없었다',
    '제 말을 전적으로 믿으셔야 합니다, 어머니',
    '후라이까지마라',
    '내가 왕이 될 상인가?',
    '헛소리하지마 인마!',
    '살아있네',
    '먹지마세요, 피부에 양보하세요',
    '사랑은 돌아오는 거야!',
    '야 창식아',
    '라면먹고 갈래요?',
    '누가 기침소리를 내었어?',
    '오늘 밤은 이 방이 최전방이야',
    '사딸라',
    '내 가치를 네가 정하지 마',
    '너나 잘하세요',
    '멋지다 연진아',
    '으에에~이쁜누나다',
    '좋았어, 진행시켜',
    '우리가 돈이 없지, 가오가 없냐?',
    '넌 나에게 모욕감을 줬어',
    '묻고 더블로 가!',
    '오겡끼데스까',
];
const Shorts = () => {
    const [scriptIndex, setScriptIndex] = useState(Math.floor(Math.random() * scriptList.length));

    return (
        <>
            <Head>
                <title>AI 성대모사 쇼츠 제작</title>
            </Head>

            <header className={styles.header}>
                <div className={styles.inner}>
                    <a
                        href={
                            process.env.NEXT_PUBLIC_NODE_ENV === 'development'
                                ? `${process.env.NEXT_PUBLIC_URL_DEV}/labs/shorts`
                                : `${process.env.NEXT_PUBLIC_URL}/labs/shorts`
                        }
                    >
                        <Logo height={20.14} />
                        <VOLI height={15} className={styles.voli} />x <span>Shorts</span>
                    </a>
                    <a
                        href={
                            process.env.NEXT_PUBLIC_NODE_ENV === 'development'
                                ? process.env.NEXT_PUBLIC_URL_DEV
                                : process.env.NEXT_PUBLIC_URL
                        }
                        className={styles.voli_link}
                    >
                        볼리 바로가기
                    </a>
                </div>
            </header>

            <div className={styles.wrap}>
                <div className={styles.container}>
                    <div className={styles.main}>
                        <img
                            src="/images/labs/shorts/background.webp"
                            alt=""
                            height={224}
                            aria-hidden
                            className={styles.background_animation}
                        />
                        <img
                            src="/images/labs/shorts/main.webp"
                            alt=""
                            width={255}
                            height={255}
                            className={styles.character}
                        />
                        <span className={styles.script}>{scriptList[scriptIndex]}</span>
                        <h2>
                            <span className={styles.label}>AI가 목소리를 바꿔줘요!</span>
                            <strong>AI 성대모사</strong> 쇼츠
                        </h2>

                        <div className={styles.bottom}>
                            <a href="/labs/shorts/start" className={styles.start_link}>
                                시작하기
                            </a>
                            <p className={styles.text}>
                                성대모사가 이렇게 쉬웠다고?
                                <br />
                                AI로 조회수 대박나는 성대모사 쇼츠 만들어봐!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Shorts;
